<template>
  <section v-if="species && huArtiklar.length > 0 && $_clientMode === 'normal'">
    <v-row class="mt-10">
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h3 class="text--secondary">
          Artiklar från tidskriften Havsutsikt
        </h3>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="hu in artiklar"
        :key="hu.id"
        :cols="$vuetify.breakpoint.smAndDown ? 12 : 4"
        class="d-flex child-flex"
      >
        <v-card class="">
          <v-img :src="$_getImage(hu.page_image)" max-height="150px"></v-img>
          <v-card-text class="pb-0">
            <div class="subtitle-1 text-uppercase color-primary">
              Havsutsikt
            </div>
          </v-card-text>
          <v-card-title> {{ hu.page_menu_title }} </v-card-title>

          <v-card-text>
            {{ hu.page_description | $_ellipsis(50) }}
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary darken-2"
              text
              target="_blank"
              :href="'https://www.havet.nu/havsutsikt/artikel/' + hu.url"
            >
              Läs
              <v-icon right>
                mdi-arrow-right
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import DataLayer from '@/store/SingleSpeciesDataLayer'
import Misc from '@/mixins/Misc.js'

export default {
  name: 'SpeciesHUarticles',
  mixins: [Misc],
  props: {
    species: { type: Object, required: true }
  },
  data() {
    return {
      huArtiklar: []
    }
  },
  mounted() {
    this.setup()
  },
  computed: {
    artiklar() {
      return this.huArtiklar.slice(0, 3)
    }
  },
  methods: {
    async setup() {
      try {
        this.huArtiklar = await DataLayer.GetRelatedNewHavsutsiktBySpecName(
          this.species.name_sve
        )
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.subtitle-1 {
  color: #7ead61;
}
</style>
